import React, { useEffect, useState } from 'react';
import { StyledModal } from './styles';

export type ModalProps = React.ComponentProps<typeof StyledModal> & {
    isOpen?: boolean;
    className?: string;
};

const Modal: React.FC<ModalProps> = ({ isOpen = false, className = '', children, ...otherProps }) => {
    const [modalOpen, setModalOpen] = useState<boolean | undefined>(undefined);
    const [modalClosing, setModalClosing] = useState(false);
    const [backgroundVisible, setBackgroundVisible] = useState(false);

    useEffect(() => {
        setModalOpen(!!isOpen);
    }, [isOpen]);

    useEffect(() => {
        if (modalOpen === undefined) return;

        if (isOpen) {
            setModalOpen(true);
            setModalClosing(false);
            setBackgroundVisible(false);
            setTimeout(() => setBackgroundVisible(true), 50);
        } else {
            setModalClosing(true);
            setTimeout(() => setBackgroundVisible(false), 250);
            setTimeout(() => {
                setModalClosing(false);
                setModalOpen(false);
            }, 650);
        }
    }, [isOpen, modalOpen]);

    return (
        <StyledModal
            isOpen={modalOpen}
            $closing={modalClosing}
            backgroundProps={{ backgroundVisible }}
            className={`rui-modal ${className}`.trim()}
            {...otherProps}
        >
            {children}
        </StyledModal>
    );
};

Modal.defaultProps = { isOpen: false };

export default Modal;
